<template>
  <div>
    <Card>
      <div class="filter-container">
        <el-input clearable
                  @keyup.enter.native="searchBtnClick"
                  style="width: 200px;"
                  class="filter-item"
                  :placeholder="$t('pages_customers_index_305')"
                  v-model="searchData.mobile" />
        <el-input clearable
                  @keyup.enter.native="searchBtnClick"
                  style="width: 200px;"
                  class="filter-item"
                  :placeholder="$t('pages_customers_index_306')"
                  v-model="searchData.username" />
        <el-input clearable
                  @keyup.enter.native="searchBtnClick"
                  style="width: 200px;"
                  class="filter-item"
                  :placeholder="$t('pages_orders_index_627')"
                  v-model="searchData.id" />
        <el-input clearable
                  @keyup.enter.native="searchBtnClick"
                  style="width: 200px;"
                  class="filter-item"
                  :placeholder="$t('pages_bills_index_197')"
                  v-model="searchData.code" />
        <el-select clearable
                   style="width: 200px"
                   class="filter-item"
                   v-model="searchData.status"
                   :placeholder="$t('pages_orders_index_628')">
          <el-option :label="$t('libs_table_render_59')"
                     value="unpaid" />
          <el-option :label="$t('libs_table_render_62')"
                     value="paid" />
        </el-select>
        <el-select clearable
                   style="width: 200px"
                   class="filter-item"
                   v-model="searchData.is_vip"
                   :placeholder="$t('pages_orders_index_629')">
          <el-option :label="$t('pages_orders_index_629')"
                     value="false" />
          <el-option :label="$t('pages_orders_index_630')"
                     value="true" />
        </el-select>
        <el-select clearable
                   style="width: 200px"
                   class="filter-item"
                   v-model="searchData.payment_method"
                   :placeholder="$t('pages_orders_index_631')">
          <el-option :label="$t('libs_table_render_74')"
                     value="cash_pay" />
          <el-option :label="$t('libs_table_render_77')"
                     value="lcsw_ali_pay" />
          <el-option :label="$t('libs_table_render_76')"
                     value="lcsw_wx_pay" />
          <el-option :label="$t('libs_table_render_75')"
                     value="svc_pay" />
          <el-option :label="$t('libs_table_render_78')"
                     value="bank_card" />
          <el-option :label="$t('libs_table_render_79')"
                     value="alipay_offline" />
          <el-option :label="$t('libs_table_render_80')"
                     value="wx_pay_offline" />
          <el-option :label="$t('libs_table_render_81')"
                     value="meituan_pay_offline" />
        </el-select>
        <el-select clearable
                   style="width: 200px"
                   class="filter-item"
                   v-model="searchData.promote_company_id"
                   @change="changeCompany"
                   :placeholder="$t('pages_customers_index_328')">
          <el-option :label="company.name" :value="company.id" v-for="company in promote_companies" :key="company.id" />
        </el-select>
        <el-select clearable
                   style="width: 200px"
                   class="filter-item"
                   v-model="searchData.promote_company_staff_id"
                   :placeholder="$t('pages_customers_index_330')">
          <el-option :label="staff.username" :value="staff.id" v-for="staff in promote_company_staffs" :key="staff.id" />
        </el-select>
        <el-date-picker type="date"
                        :placeholder="$t('pages_bills_index_194')"
                        v-model="searchData.start_at"
                        style="width: 200px;"
                        class="filter-item"
                        value-format="yyyy-MM-dd"></el-date-picker>
        <el-date-picker type="date"
                        :placeholder="$t('pages_bills_index_195')"
                        v-model="searchData.end_at"
                        style="width: 200px;"
                        class="filter-item"
                        value-format="yyyy-MM-dd"></el-date-picker>
        <el-button size="medium"
                   class="filter-item"
                   type="primary"
                   icon="el-icon-search"
                   @click="searchBtnClick()">{{$t('pages_bills_index_196')}}</el-button>
        <el-button size="medium"
                   class="filter-item"
                   type="primary"
                   :loading="exportLoading"
                   icon="el-icon-download"
                   @click="exportData">{{$t('pages_customers_index_311')}}</el-button>
        <!-- <el-button
          size="medium"
          class="filter-item"
          style="margin-left: 10px;"
          @click="handleDownload"
          type="danger"
          icon="el-icon-download"
          :loading="downloadLoading"
        >导出Excel</el-button>
        <el-button
          size="medium"
          class="filter-item"
          style="margin-left: 10px;"
          v-checkBuyedPlugin="[9]"
          @click="openDown2"
          type="danger"
          icon="el-icon-download"
        >导出销售明细</el-button>-->
      </div>
      <el-alert v-if="aggregate_test"
                :title="aggregate_test"
                type="success"
                :closable="false"></el-alert>
      <i-table style="margin-top: 20px;"
             ref="order"
             border
             :loading="loading"
             :columns="columns"
             :data="orders"
             :changePage="changePage"
             @on-row-click="onRowClick"></i-table>
      <Row>
        <Page style="margin-top: 20px;"
              show-total
              :total="meta.total"
              :current="meta.current"
              :page-size="meta.pageSize"
              @on-change="changePage"></Page>
      </Row>
    </Card>
    <!-- style="display: none" -->
    <table ref="exportTable" style="display: none">
      <thead>
        <tr>
          <th>{{$t('pages_orders_index_632')}}</th>
          <th v-for="item in exportFields"
              :key="item.key">{{ item.title }}</th>
          <th>{{$t('pages_balance_transaction_index_177')}}</th>
        </tr>
      </thead>
      <template v-for="(item) in ordersAll">
        <tr :key="item.id">
          <td :rowspan="item.firstRow.rowspan">{{ item.firstRow.name }}</td>
          <td v-for="(field) in exportFields" :key="item.id + field.key">{{ getExportColumnData(item.firstRow.data, field) }}</td>
          <td :rowspan="item.firstRow.rowspan">{{ item.firstRow.created_at_str }}</td>
        </tr>
        <tr v-for="(row, ri) in item.otherRows" :key="item.id + '' + ri + '2'">
          <td v-for="(field) in exportFields" :key="item.id + field.key + $t('pages_orders_index_633')">{{ getExportColumnData(row, field) }}</td>
        </tr>
      </template>
    </table>
  </div>
</template>

<script>
import i18n from '../../locales/index'

import { mapGetters, mapActions, mapMutations } from 'vuex'
import { booleanChinese, podStatus, paymentChinese, comeFromChinese, orderTypeChinese } from '@/libs/table-render'
import axios from 'axios'
import _ from 'lodash';

const exportFields = [
  {
    title: i18n.t('pages_orders_index_634'),
    key: 'fresh_product_bar_code',
  },
  {
    title: i18n.t('pages_orders_index_635'),
    key: 'fresh_product_specs',
  },
  {
    title: i18n.t('pages_orders_index_636'),
    key: 'current_product_name',
  },
  {
    title: i18n.t('pages_bookings_detail_224'),
    key: 'current_price'
  },
  {
    title: i18n.t('pages_orders_index_637'),
    key: 'quantity',
  },
  {
    title: i18n.t('pages_dashboards_statement_product_index_375'),
    key: 'total',
  },
  // {
  //   title: '创建时间',
  //   key: 'created_at_str',
  // },
  // {
  //   title: '销售占比',
  //   key: 'percentage',
  // },
];

export default {
  data () {
    return {
      exportFields,
      searchData: {
        id: undefined
      },
      columns: [
        {
          title: 'ID',
          key: 'id',
          width: 100,
          align: 'center'
        },
        {
          title: i18n.t('pages_balance_transaction_index_177'),
          key: 'created_at_str',
          width: 180,
          align: 'center'
        },
        {
          title: i18n.t('pages_orders_index_638'),
          key: 'come_from',
          width: 100,
          align: 'center',
          render: (h, params) => {
            return comeFromChinese(h, params.row.come_from)
          }
        },
        {
          title: i18n.t('pages_orders_index_639'),
          key: 'delivery',
          width: 100,
          align: 'center',
          render: (h, params) => {
            return orderTypeChinese(h, params.row.delivery)
          }
        },
        {
          title: i18n.t('pages_bills_index_197'),
          key: 'code',
          width: 160,
          align: 'center'
        },
        {
          title: i18n.t('pages_bills_index_198'),
          key: 'status',
          width: 120,
          align: 'center',
          render: (h, params) => {
            return paymentChinese(h, params.row.status)
          }
        },
        {
          title: i18n.t('pages_bills_index_199'),
          key: 'payment_method',
          width: 120,
          align: 'center',
          render: (h, params) => {
            return podStatus(h, params.row.payment_method)
          }
        },
        {
          title: i18n.t('pages_bills_index_200'),
          key: 'fresh_customer_username',
          width: 180,
          align: 'center'
        },
        {
          title: i18n.t('pages_bills_index_201'),
          key: 'fresh_customer_mobile',
          width: 180,
          align: 'center'
        }
      ].concat(localStorage.getItem('SHOP_TYPE') === 'chinese' ? [ // 餐饮行业
        {
          title: i18n.t('pages_orders_index_640'),
          key: 'fresh_desk_name',
          width: 180,
          align: 'center'
        },
        {
          title: i18n.t('pages_orders_index_641'),
          key: 'average_price',
          width: 100,
          align: 'center'
        }] : []).concat([
        {
          title: i18n.t('pages_customers_orders_351'),
          key: 'total',
          width: 100,
          align: 'center'
        },
        {
          title: i18n.t('pages_customers_orders_352'),
          key: 'discount',
          width: 100,
          align: 'center',
          render: (h, params) => {
            return h('div', params.row.discount + '%')
          }
        },
        {
          title: i18n.t('pages_customers_orders_353'),
          key: 'small_discount',
          width: 100,
          align: 'center',
          render: (h, params) => {
            return booleanChinese(h, params.row.small_discount)
          }
        },
        {
          title: i18n.t('pages_customers_orders_354'),
          key: 'discounted_total',
          width: 100,
          align: 'center'
        },
        {
          title: i18n.t('pages_customers_orders_355'),
          key: 'finish_total',
          width: 100,
          align: 'center'
        },
        {
          title: i18n.t('pages_customers_orders_356'),
          key: 'payment_total',
          width: 100,
          align: 'center'
        },
        {
          title: i18n.t('pages_customers_orders_357'),
          key: 'change_amount',
          width: 100,
          align: 'center'
        },
        {
          title: i18n.t('pages_orders_index_642'),
          key: 'offline_coupon',
          width: 100,
          align: 'center'
        },
        // {
        //   title: '分佣金额',
        //   key: 'rebate_price',
        //   width: 100,
        //   align: 'center',
        //   render: (h, params) => {
        //     return params.row.promote_company_staff_id ? h('div', params.row.rebate_price) : ''
        //   }
        // },
        // {
        //   title: '已分佣',
        //   key: 'is_finish_rebate',
        //   width: 100,
        //   align: 'center',
        //   render: (h, params) => {
        //     return params.row.promote_company_staff_id ? booleanChinese(h, params.row.is_finish_rebate) : ''
        //   }
        // },
        {
          title: i18n.t('pages_bookings_index_230'),
          key: 'description',
          width: 200,
          align: 'center'
        }
      ]),
      exportLoading: false,
      ordersAll: []
    }
  },
  created () {
    this.resetQuery()
    this.index()
    this.companyIndex()
  },
  computed: {
    ...mapGetters('order', ['orders', 'meta', 'loading', 'aggregate_test']),
    ...mapGetters('shop', ['shops']),
    ...mapGetters('promote_company', ['promote_companies']),
    ...mapGetters('promote_company_staff', ['promote_company_staffs']),
  },
  methods: {
    ...mapActions('order', ['index']),
    ...mapActions('shop', { getShops: 'index' }),
    ...mapActions('promote_company', { companyIndex: 'index' }),
    ...mapActions('promote_company_staff', { staffIndex: 'index' }),
    ...mapMutations('order', ['changeQuery', 'resetQuery']),
    ...mapMutations('promote_company_staff', { changeStaffQuery: 'changeQuery' }),
    mergeOrderItems (list1 = [], list2 = []) {
      const result1 = [];
      const result2 = [];
      // console.log(list1, list2, '=====>')
      list1.forEach(item1 => {
        const findItem = list2.find(item2 => item2.fresh_product_id === item1.fresh_product_id && item2.fresh_product_specs === item1.fresh_product_specs)
        if (findItem) {
          result1.push({
            ...item1,
            quantity: findItem.quantity + item1.quantity,
            total: findItem.total + item1.total,
          })
        } else {
          result1.push({
            ...item1
          })
        }
      })
      list2.forEach(item2 => {
        const findItem = list1.find(item1 => item1.fresh_product_id === item2.fresh_product_id && item1.fresh_product_specs === item2.fresh_product_specs)
        if (!findItem) {
          result2.push({
            ...item2
          })
        }
      })
      return [...result1, ...result2]
    },
    async exportData () {
      this.exportLoading = true;
      axios.get('orders', { params: { ...this.searchData, ...{ per: 65535, page: 1 } } }).then(({ data: list }) => {
        this.exportLoading = false
        const map = {}
        list.forEach((item) => {
          if (map[item.shop_name]) {
            map[item.shop_name].fresh_order_items = this.mergeOrderItems(map[item.shop_name].fresh_order_items, item.fresh_order_items)
          } else {
            map[item.shop_name] = {
              id: item.id,
              created_at_str: item.created_at_str,
              fresh_order_items: item.fresh_order_items || []
            }
          }
        })
        // console.log('map', map)
        this.ordersAll = Object.keys(map).map(key => {
          return { firstRow: { rowspan: map[key].fresh_order_items.length, name: key, data: map[key].fresh_order_items[0] || {}, created_at_str: map[key].created_at_str }, otherRows: map[key].fresh_order_items.slice(1), id: map[key].id, }
        })
        // console.log('this.ordersAll', this.ordersAll)
        setTimeout(() => {
          const book = XLSX.utils.book_new();
          const s1 = XLSX.utils.table_to_sheet(this.$refs.exportTable);
          XLSX.utils.book_append_sheet(book, s1, i18n.t('pages_orders_index_643'));
          const base64 = XLSX.write(book, { bookType: 'xlsx', type: 'base64' });
          const a = document.createElement('a');
          a.setAttribute('download', i18n.t('pages_orders_index_643'));
          a.href = 'data:application/vnd.ms-excel;base64,' + base64;
          a.click();
        }, 20);
      })
    },
    changeCompany (value) {
      // console.info('changeCompany', value)
      if (value) {
        this.changeStaffQuery({
          promote_company_id: value
        })
        this.staffIndex()
      } else {
        this.searchData.promote_company_staff_id = ''
      }
    },
    changePage (page) {
      this.changeQuery({ page })
      this.index()
    },
    onRowClick (params) {
      this.$router.push(`/orders/${params.id}`)
    },
    searchBtnClick () {
      this.resetQuery()
      this.changeQuery(this.searchData)
      this.index()
    },
    getExportColumnData (row, config) {
      const val = _.get(row, config.key);
      return config.render ? config.render(val) : val
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="less">
.filter-container {
  padding-bottom: 10px;
  > div {
    margin-right: 8px;
  }
  .filter-item {
    display: inline-block;
    vertical-align: middle;
    margin-bottom: 10px;
  }
}
</style>
